import { KINDS } from './kinds'

/**
 * «‹» библиотеки (аватары, локации, предметы) ведёт туда, откуда в неё вошли (владелец 11.10): из кабинета — назад в
 * кабинет, из «Сцены» и по прямой ссылке — к проектам «Сцены», как было. Кабинет передаёт метку в переходе
 * (state.libraryBack), библиотека запоминает её на вкладку: метка переживает переходы внутри библиотеки (раздел →
 * аватар → версия) и F5, а App снимает её, как только человек ушёл из библиотеки.
 */
export interface LibraryBack {
	to: string
	label: string
}

/** Откуда можно войти в библиотеку со своим возвратом. Адрес не берётся из хранилища — только из этого списка. */
const ORIGINS = {
	account: { to: '/account', label: 'Назад в аккаунт' },
} satisfies Record<string, LibraryBack>

export type LibraryOrigin = keyof typeof ORIGINS

const KEY = 'sc_library_back'
const LIBRARY_PATHS = Object.values(KINDS).map((k) => k.path)

export function isLibraryPath(pathname: string): boolean {
	return LIBRARY_PATHS.some((p) => pathname === p || pathname.startsWith(`${p}/`))
}

/** Метка входа из перехода (state) — у первой страницы библиотеки после кабинета. */
export function originOfState(state: unknown): LibraryOrigin | null {
	const v = (state as { libraryBack?: unknown } | null)?.libraryBack
	return typeof v === 'string' && v in ORIGINS ? (v as LibraryOrigin) : null
}

export function rememberLibraryOrigin(origin: LibraryOrigin): void {
	try {
		sessionStorage.setItem(KEY, origin)
	} catch {
		/* без хранилища «‹» дальше первой страницы ведёт к «Сцене», как раньше */
	}
}

export function forgetLibraryOrigin(): void {
	try {
		sessionStorage.removeItem(KEY)
	} catch {
		/* нечего снимать */
	}
}

/** Куда ведёт «‹» библиотеки: метка перехода, иначе запомненная на вкладку; null — к проектам «Сцены». */
export function libraryBack(origin: LibraryOrigin | null): LibraryBack | null {
	let o: string | null = origin
	if (!o) {
		try {
			o = sessionStorage.getItem(KEY)
		} catch {
			o = null
		}
	}
	return o && o in ORIGINS ? ORIGINS[o as LibraryOrigin] : null
}
